import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

function Index() {
  const [boardName, setBoardName] = useState("");
  const [additionalFeePercentage, setAdditionalFeePercentage] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  console.log("Board ID from URL:", id);

  //get api se board ka data lana hai id ke sath input field mai show karne ke liye
  //aur fir update karne ke liye put api call karni hai

  useEffect(() => {
    axios
      .get(`${baseURL}/boards/${id}`)
      .then((res) => {
        console.log("Board details:", res.data);
        if (res.data.success) {
          setBoardName(res.data.data.name);
          setAdditionalFeePercentage(
            res.data.data.additionalFeePercentage !== undefined &&
              res.data.data.additionalFeePercentage !== null
              ? String(res.data.data.additionalFeePercentage)
              : ""
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching board details:", err);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!boardName.trim()) {
      toast.error("Board name cannot be empty");
      //   alert("Please enter class name");
      return;
    }
    const feePercentageValue = Number(additionalFeePercentage || 0);
    if (!Number.isFinite(feePercentageValue) || feePercentageValue < 0) {
      toast.error("Additional fee percentage must be 0 or more");
      return;
    }
    console.log("New Board Added:", boardName);
    // setBoardName(""); // reset input

    axios
      .put(`${baseURL}/boards/${id}`, {
        name: boardName,
        additionalFeePercentage: feePercentageValue,
      })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "Board updated successfully");
        navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error updating class:", error);
        // toast.error(error.response?.data?.message || "Failed to update class");
        toast.error(error.response?.data?.error);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Edit Board Name
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" alignItems="center" gap={2}>
                {/* Input Field */}
                <ArgonBox>
                  <ArgonInput
                    type="text"
                    placeholder="Enter Board Name"
                    value={boardName}
                    onChange={(e) => setBoardName(e.target.value)}
                    sx={{ width: "50%" }}
                  />
                </ArgonBox>
                <ArgonBox>
                  <ArgonInput
                    type="number"
                    placeholder="Additional Fee %"
                    value={additionalFeePercentage}
                    onChange={(e) => setAdditionalFeePercentage(e.target.value)}
                    inputProps={{ min: 0, step: "0.01" }}
                    sx={{ width: "50%" }}
                  />
                </ArgonBox>                {/* Button */}
                <ArgonButton
                  color="primary"
                  type="submit"
                  variant="contained"
                  // sx={{ minWidth: "150px", height: "100%" }}
                >
                  Update Board
                </ArgonButton>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;

